export default __webpack_public_path__ + "static/media/background.129d030d.jpeg";